<template>
  <div class="export-pdf-container">
    <div style="padding: 40px 40px 0 40px">
      <img :src="'img/imgPdf/aboutupm.png'" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUpmPdf"
};
</script>

<style scoped></style>
